(function(Accordion, $, undefined) {
  
  var bindUIActions = function() {
    $('[data-toggle-accordion]').on('click', function() {
      const $accordion = $(this).closest('.accordion-new');
      const $content = $(this).next();
      
      $('.accordion-new__content').slideUp(300);
      $('.accordion-new').removeClass('accordion-new--open');
      
      if ($content.is(':visible')) {
        $accordion.removeClass('accordion-new--open');
        $content.slideUp(300).promise().done(function() {
          Waypoint.refreshAll();
        });
      } else {
        $accordion.addClass('accordion-new--open');
        $(this).next().slideDown(300).promise().done(function() {
          Waypoint.refreshAll();
        });;
      }
    })
  }

  Accordion.init = function() {
    bindUIActions();
  }

}(window.Accordion = window.Accordion || {}, jQuery));